export default {
  text: {
    en: `Your card was declined, <br class="onlyMobile" />please update your payment info`,
  },
}
